import { Injectable }       from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
}                           from '@angular/router';
import {AuthService} from '../shared/auth/auth.service';

@Injectable()
export class HomeRedirectionService implements CanActivate {
    constructor(private auth: AuthService) {}

    /**
     * can activate login page ?
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return this.auth.authorize(false).then( canActivate => canActivate);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home-redirection.service.ts